import type { ReactNode } from 'react';

// The chrome the board routes share — /disruptions and the operator's home (/dashboard,
// «Resumen») — so the two screens read alike (PO 2026-11-01: «difieren mucho
// estéticamente… debemos unificar el criterio»):
//
//   - `PageHeader` — the header band (Operar's: the title big on the left, then
//     `children`, and `actions` pushed to the right);
//   - `CountChip` — the mono count beside a group's name (Operar's «PNRs N»).

/** The header band. Wraps under `lg` instead of pushing the frame sideways (§18.2). */
export function PageHeader({
  title,
  children,
  actions,
  testId,
}: {
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
  testId: string;
}) {
  return (
    <header
      className="shrink-0 border-b border-border bg-background px-4 py-2 lg:px-6"
      data-testid={testId}
    >
      <div className="flex min-h-14 w-full flex-wrap items-center gap-x-4 gap-y-2">
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        {children}
        {actions ? <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
    </header>
  );
}

/** The count chip beside a group's name — mono, on a muted pill (Operar's «PNRs N»). */
export function CountChip({ n, testId }: { n: number; testId: string }) {
  return (
    <span
      className="rounded-full bg-muted px-2 py-0.5 font-mono text-xs font-bold tabular-nums text-muted-foreground"
      data-testid={testId}
    >
      {n.toLocaleString()}
    </span>
  );
}
